import React, { useCallback, useEffect, useState } from "react"
import { Modal, ModalBody, Table } from "reactstrap";
import DatePicker from "web/components/DatePicker";
import { InnerHeader, SelectWrapper, SelectWrapperMulti, SearchWrapper, AdjInvoiceTableContainer, PaidDateModal } from "./AdjustmentInvoicesStyled";
import * as moment from 'moment';
import { AiOutlineSearch } from "react-icons/ai";
import { Pagination } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AlertModal from "web/components/AlertModal";
import { hideAppLoader } from 'redux/actions/app';
import debounce from "lodash.debounce";
import { adjustmentInvoiceStausUpdateApiFunc, ptPlusPaymentAdjumentInvoiceDownload, ptPlusPaymentAdjumentInvoices } from "redux/actions/adminPtPlusOrdersPaymentAdjustments";
import DownloadInvoiceIcon from "web/assets/svg/DownloadInvoiceIcon";
import DatePickerPaidModal from "../OrderInvoices/headingSection/DatePicker";
import Spinner from "web/components/Spinner";

const AdjustmentInvoices = ({ TabPanel, value }) => {

  const dispatch = useDispatch()
  const history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible)

  let headerArr = [
    { title: 'Order Id' },
    { title: 'Company Name' },
    { title: 'Invoice Id' },
    { title: 'Invoice Date' },
    { title: 'Adj. Amount' },
    { title: 'Adj. Type' },
    { title: 'Description' },
    { title: 'Invoice Status' },
    {title: "Payment Date"},
    { title: 'Download Invoice' }
  ];

  const [finalData, setFinalData] = useState([]);
  const [tableSearch, setTableSearch] = useState('')
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  let toDatePTAdjInvoice = new Date();

  let fromDatePTAdjInvoice = new Date();
  fromDatePTAdjInvoice.setMonth(fromDatePTAdjInvoice.getMonth() - 6)


  const [startDateValue, setStartDateValue] = useState(moment(fromDatePTAdjInvoice).format("MM/DD/YYYY"))
  const [endDateValue, setEndDateValue] = useState(moment(toDatePTAdjInvoice).format("MM/DD/YYYY"))
  const [userFilterState, setUserFilterState] = useState({
    fromDate: moment(fromDatePTAdjInvoice).format("MM/DD/YYYY"),
    toDate: moment(toDatePTAdjInvoice).format("MM/DD/YYYY"),
    company: "ALL"
  })

  let dateLimit = new Date()
  dateLimit.setDate(dateLimit.getDate() - 60);
  let todayDate = new Date();
  todayDate = moment(todayDate).format("MM/DD/YYYY")
  const [defaultDateValue, setDefaultDateValue] = useState(new Date(todayDate))
  let tempFromDate = (moment(todayDate)).valueOf()
  tempFromDate = Math.trunc(tempFromDate / 1000) + 61200
  const [paidDateValue, setPaidDateValue] = useState(tempFromDate)
  const [payModal, setPayModal] = useState(false)
  const [apiPayloadTempSave, setApiPayloadTempSave] = useState()

  function formatDate(date) {
    return moment(date).format("YYYY-MM-DD")
  }

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchPtPlusPaymentAdjustmentInvoices(0)
  }, []);

  const fetchPtPlusPaymentAdjustmentInvoices = async (selectPage, search, getFromDate, getToDate) => {
    
    if((!getFromDate || !getToDate) && (!userFilterState.toDate || !userFilterState.fromDate)){
      setModalContent("Please enter the correct Date Range.");
      setModalLink("");
      toggleModal();
      return
    }

    let data = {
      size: 10,
      number: selectPage,
      sort: "DESC",
      searchBy: search || tableSearch || "",
      fromDate: getFromDate ? formatDate(getFromDate) : (userFilterState.fromDate && formatDate(userFilterState.fromDate)),
      toDate: getToDate ? formatDate(getToDate) : (userFilterState.toDate && formatDate(userFilterState.toDate)),
    }
    let response = await dispatch(ptPlusPaymentAdjumentInvoices(data))
    if (response && response?.success) {
      dispatch(hideAppLoader());
      if (response?.data?.invoiceList && response?.data?.invoiceList.length > 0) {
        setFinalData(response?.data?.invoiceList)
        setPageCount(response?.data?.totalPages)
      } else {
        setFinalData([])
        setPageCount(0)
      }
    } else {
      dispatch(hideAppLoader());
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again!')
        setModalLink("");
        toggleModal();
      }
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    setFinalData([])
    fetchPtPlusPaymentAdjustmentInvoices(value - 1, tableSearch)
  };

  const handleDebounceOrderReportSearch = useCallback(
    debounce((selectPage, searchtext) => fetchPtPlusPaymentAdjustmentInvoices(selectPage, searchtext), 500),
    []
  );

  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    setPage(1)
    let searchtext = e.target.value
    setFinalData([])
    handleDebounceOrderReportSearch(0, searchtext);
  }

  const updateAdjPaymentStatusFunc = async (items, date) => {
    let data = {
      markPaid: true,
      date: date,
      invoiceId: items.invId
    }
    let response = await dispatch(adjustmentInvoiceStausUpdateApiFunc(data));
    if (response?.data?.success) {
      fetchPtPlusPaymentAdjustmentInvoices(0)
      setModalContent('Invoice status marked as paid.')
      setModalLink("");
      setPayModal(false)
      setModal(!modal)
    } else {
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalLink("");
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again!')
        setPayModal(false)
        setModal(!modal)
      }
    }
  }

  //DownloadInvoice function
  const downloadInvoice = async (invoiceId) => {
    let response = await dispatch(ptPlusPaymentAdjumentInvoiceDownload(invoiceId));

    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ptplus_adjustment_invoice.pdf");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <TabPanel value={value} index={1}>
      {loaderVisible && <Spinner />}
      <InnerHeader>
        <SelectWrapperMulti>
          <label className="">From:</label>
          <DatePicker
            name="fromDatePTAdjInvoice"
            maxDOBirth={userFilterState.toDate}
            value={userFilterState.fromDate}
            inputValue={startDateValue}
            callBackFun={(date, value) => {
              setStartDateValue(value)
              if (moment(date, moment.ISO_8601, true).isValid()) {
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["fromDate"]: moment(date).format("MM/DD/YYYY"),
                }));
              } else if (!date || date.toString() === "Invalid Date") { // Check if date is null or undefined
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["fromDate"]: null,
                }));
              }
            }}
          />
        </SelectWrapperMulti>
        <SelectWrapperMulti>
          <label className="">To:</label>
          <DatePicker
            name="toDatePTAdjInvoice"
            minDOBirth={userFilterState.fromDate}
            value={userFilterState.toDate}
            inputValue={endDateValue}
            callBackFun={(date, value) => {
              setEndDateValue(value)
              if (moment(date, moment.ISO_8601, true).isValid()) {
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["toDate"]: moment(date).format("MM/DD/YYYY"),
                }));
              } else if (!date || date.toString() === "Invalid Date") { // Check if date is null or undefined
                setUserFilterState((prevState) => ({
                  ...prevState,
                  ["toDate"]: null,
                }));
              }
            }}
          />
        </SelectWrapperMulti>
        <SelectWrapper>
          <label style={{ marginTop: "22px", backgroundColor: "transparent" }}></label>
          <button
            onClick={() => {
              setPage(1)
              setFinalData([])
              fetchPtPlusPaymentAdjustmentInvoices(0, tableSearch);
            }}
          >
            Submit
          </button>
        </SelectWrapper>

        <div className="search-input-wrapper">
          <SearchWrapper>
            <input
              type="text"
              placeholder='Search'
              value={tableSearch}
              onChange={(e) => {
                handleSearchChange(e, value)
              }}
            />
            <AiOutlineSearch />
          </SearchWrapper>
        </div>
      </InnerHeader>

      <AdjInvoiceTableContainer>
        <Table responsive>
          <thead>
            <tr>
              {headerArr.map((items, index) => (
                <th key={index}>
                  {items.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {finalData && finalData.length > 0 ? (
              finalData.map((items, index) => (
                <tr key={index} className='user-list-table-styles'>
                  <td>{items?.orderId || "NA"}</td>
                  <td>{items?.billToLocationName || "NA"}</td>
                  <td>{items?.invId || "NA"}</td>
                  <td>{items?.invoiceDate || "NA"}</td>
                  <td>{items?.adjAmount ? `$${items?.adjAmount?.toFixed(2)}` : "NA"}</td>
                  <td>{items?.adjType || "NA"}</td>
                  <td title={items?.adjReason}>{items?.adjReason?.length > 0 ? (items?.adjReason?.length > 15 ? items?.adjReason.substring(0, 15) + '...' : items?.adjReason) : "NA"}</td>
                  <td>
                    {items?.invoiceStatus === "PAID" ? (
                      <button style={{
                        padding: "5px 15px",
                        background: "#61AE24",
                        borderRadius: "4px",
                        border: "none",
                        fontFamily: 'Latoregular',
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "15px",
                        lineHeight: "18px",
                        color: "#FFFFFF",
                        textAlign: "center",
                        cursor: 'default'
                      }}
                        onClick={() => {
                        }}
                      >Paid</button>
                    ) : (
                      <button style={{
                        padding: "5px 15px",
                        background: "#fff",
                        borderRadius: "4px",
                        border: "1px solid",
                        fontFamily: 'Latoregular',
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "15px",
                        lineHeight: "18px",
                        color: "black",
                        textAlign: "center"
                      }}
                        onClick={() => {
                          setPayModal(true)
                          setApiPayloadTempSave(items)
                        }}>Mark Paid</button>
                    )}{" "}
                  </td>
                  <td>
                    {(items?.invoiceStatus === "PAID") ? (items?.paymentDate ? items?.paymentDate : "NA") : ""}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <div
                      onClick={() => {
                        downloadInvoice(
                          items?.invId
                        )}
                      }
                    >
                      <DownloadInvoiceIcon />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headerArr?.length} style={{ position: 'relative', textAlign: 'center' }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </AdjInvoiceTableContainer>
      {pageCount && finalData && finalData?.length !== 0 ? <Pagination count={pageCount}
        page={page}
        onChange={handlePageChange} /> : ""}
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={modalTitle}
        content={modalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
        callBackAlert={(val) => {
          if (val === "success") history.push('/ptplus-reports')
          else toggleModal()
        }}
      />
      <Modal isOpen={payModal} centered={true}>
        <PaidDateModal>
          <ModalBody>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
              <p>Are you sure you want to mark as Paid?</p>
              <DatePickerPaidModal
                name="fromDate"
                minDOBirth={dateLimit}
                maxDOBirth={todayDate}
                value={defaultDateValue}
                callBackFun={(date) => {
                  setDefaultDateValue(date)
                  let tempFromDate = moment(date).format("MM/DD/YYYY")
                  tempFromDate = (new Date(tempFromDate) / 1000) + 61200
                  setPaidDateValue(tempFromDate)
                }}
              />
              <div style={{ display: 'flex', justifyContent: 'end', marginTop: '25px' }}>
                <button
                  className="cancel-button"
                  onClick={() => {
                    setDefaultDateValue(new Date(todayDate))
                    let tempFromDate = (moment(todayDate)).valueOf()
                    tempFromDate = Math.trunc(tempFromDate / 1000) + 61200
                    setPaidDateValue(tempFromDate)
                    setPayModal(false)
                  }}>No</button>
                <button
                  className="buttonStyle"
                  onClick={() => {
                    setDefaultDateValue(new Date(todayDate))
                    let tempFromDate = (moment(todayDate)).valueOf()
                    tempFromDate = Math.trunc(tempFromDate / 1000) + 61200
                    setPaidDateValue(tempFromDate)
                    setPayModal(false)
                    updateAdjPaymentStatusFunc(apiPayloadTempSave, paidDateValue)
                  }}>Yes</button>
              </div>
            </div>
          </ModalBody>
        </PaidDateModal>
      </Modal>
    </TabPanel>
  )
}

export default AdjustmentInvoices